import React, { useContext } from 'react';
import { Card, Col, Row, DatePicker, Switch, Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import firebase from 'firebase';
import checkPermission from '../../../../components/Authorization/Util';
import UserContext from '../../../layout/UserContext';
import ImageUploader from '../../../../firebase/ImageUploader';

const General = ({ formData, form, submit }) => {
  const onUploadSuccessHandleForm = value => {
    
    form.setFieldsValue({
      image: value,
    });
  };

  const getDraggerValue = () => {
    
    const draggerValue = form.getFieldValue('image');
    return draggerValue;
  };

  const { getFieldDecorator } = form;
  const value = useContext(UserContext);

  const disable = !checkPermission(value, 'appcms', 'write');

  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <div>
      <Row>
        <Col span={13}>
          <Row>
            <Col span={24}>
              <Card bordered={false}>
                <Form.Item label="Date">
                  {getFieldDecorator('date', {
                    rules: [
                      {
                        required: true,
                        message: 'Date is required',
                      },
                    ],
                    initialValue:
                      formData && formData.data.date
                        ? moment(formData.data.date, 'YYYY-MM-DD')
                        : undefined,
                  })(<DatePicker disabled={disable} />)}
                </Form.Item>

                <Form.Item
                  label={
                    <span>
                      Published&nbsp;
                      <Tooltip title="This news will only be shown on the app if Published is switched on.">
                        <InfoCircleOutlined />
                      </Tooltip>
                    </span>
                  }
                >
                  {getFieldDecorator('published', {
                    valuePropName: 'checked',
                    initialValue:
                      formData && formData.data.published
                        ? formData.data.published
                        : undefined,
                  })(<Switch disabled={disable} />)}
                </Form.Item>
              </Card>
            </Col>
          </Row>
        </Col>
        <Col span={11}>
          <Card bordered={false}>
            <Form.Item
              wrapperCol={{ xs: { span: 24 } }}
              style={{ display: 'flex' }}
            >
              {getFieldDecorator('image', {
                valuePropName: 'file',
              })(
                <Card title="Image">
                  <Row justify="center">
                    <div className="clearfix">
                      <ImageUploader
                        storageRef={firebase
                          .storage()
                          .ref(
                            window.location.hostname.split('.')[0] +
                              '/news-images',
                          )}
                        handleFormValue={onUploadSuccessHandleForm}
                        getDraggerValue={getDraggerValue}
                        storageFolder={
                          window.location.hostname.split('.')[0] +
                          '/news-images'
                        }
                        imageListData={
                          formData ? formData.data.image : undefined
                        }
                        maxCount={1}
                        disabledAdd={!checkPermission(value, 'appcms', 'write')}
                        submit={submit}
                      />
                    </div>
                  </Row>
                </Card>,
              )}
            </Form.Item>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

General.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  form: PropTypes.object,
  formData: PropTypes.object,
  submit: PropTypes.func,
};

General.contextType = UserContext;

function mapStateToProps({ objectNumReducer }) {
  const { objectNumList } = objectNumReducer;
  return {
    objectNumList,
  };
}

export default connect(mapStateToProps, {})(General);
